module.exports = __webpack_public_path__ + "static/media/jobfamily_inactive.0ce1c07a.svg";